import React from "react";
import { Lightbulb, Target, Compass } from "lucide-react";
import SectionHeading from "../ui/SectionHeading";

const Vision = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="lg:col-span-1">
            <div className="sticky top-24">
              <SectionHeading
                title="Our Vision & Values"
                subtitle="Professional Service Associates is built on strong principles that guide our approach to client service."
              />
            </div>
          </div>

          <div className="lg:col-span-2 space-y-16">
            <div className="bg-white p-8 rounded-lg shadow-md border border-gray-100">
              <div className="bg-psa-green-50 p-4 inline-block rounded-lg mb-6">
                <Lightbulb size={32} className="text-psa-green-600" />
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                Our Vision
              </h3>
              <p className="text-gray-700 leading-relaxed">
                To be the most trusted Tax, VAT, RJSC, BIDA and business
                consultancy firm in Bangladesh, recognized for our expertise,
                integrity, and commitment to client success. We envision a
                business landscape where companies can thrive through proper
                financial management and regulatory compliance.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md border border-gray-100">
              <div className="bg-psa-green-50 p-4 inline-block rounded-lg mb-6">
                <Target size={32} className="text-psa-green-600" />
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                Our Mission
              </h3>
              <p className="text-gray-700 leading-relaxed">
                To provide comprehensive, personalized Tax, VAT, RJSC, BIDA and
                business consultancy services that empower our clients to make
                informed financial decisions, minimize Tax liabilities, and
                achieve sustainable growth. We are committed to delivering
                exceptional value through our expertise, responsiveness, and
                dedication to client satisfaction.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md border border-gray-100">
              <div className="bg-psa-green-50 p-4 inline-block rounded-lg mb-6">
                <Compass size={32} className="text-psa-green-600" />
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                Our Values
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div>
                  <h4 className="font-semibold text-psa-green-600 mb-2">
                    Integrity
                  </h4>
                  <p className="text-gray-700">
                    We uphold the highest ethical standards in all our
                    interactions and services.
                  </p>
                </div>
                <div>
                  <h4 className="font-semibold text-psa-green-600 mb-2">
                    Excellence
                  </h4>
                  <p className="text-gray-700">
                    We strive for excellence in every service we provide,
                    ensuring quality and accuracy.
                  </p>
                </div>
                <div>
                  <h4 className="font-semibold text-psa-green-600 mb-2">
                    Client-Centered
                  </h4>
                  <p className="text-gray-700">
                    We put our clients' needs first, tailoring our services to
                    their unique situations.
                  </p>
                </div>
                <div>
                  <h4 className="font-semibold text-psa-green-600 mb-2">
                    Innovation
                  </h4>
                  <p className="text-gray-700">
                    We continually update our knowledge and approach to provide
                    cutting-edge solutions.
                  </p>
                </div>
                <div>
                  <h4 className="font-semibold text-psa-green-600 mb-2">
                    Collaboration
                  </h4>
                  <p className="text-gray-700">
                    We work closely with our clients, forming partnerships based
                    on trust and mutual respect.
                  </p>
                </div>
                <div>
                  <h4 className="font-semibold text-psa-green-600 mb-2">
                    Accountability
                  </h4>
                  <p className="text-gray-700">
                    We take responsibility for our work and stand behind our
                    recommendations and services.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
